import { Image } from "react-bootstrap";
import { Link } from "react-router-dom";


import ico_01 from '../../assets/img/ico_01.svg';
import ico_02 from '../../assets/img/ico_02.svg';
import ico_03 from '../../assets/img/ico_03.svg';
import ico_04 from '../../assets/img/ico_04.svg';

function SideNav() {

    return (
        <div>
            <div class="lh">            
                <Link to="../Menu" class="btn_side">
                    <span class="ico_btn_side"><Image src={ico_01}></Image></span>
                    <span class="label_btn_side">Menu System</span>
                </Link>
            </div>
            <div class="lh">
                <Link to="../Management" class="btn_side">
                    <span class="ico_btn_side"><Image src={ico_02}></Image></span>
                    <span class="label_btn_side">Management System</span>
                </Link>
            </div>
            <div class="lh">
                <Link to="../Ticket" class="btn_side">
                    <span class="ico_btn_side"><Image src={ico_03}></Image></span>
                    <span class="label_btn_side">Tray Ticket System</span>
                </Link>
            </div>
            <div class="lh">
                <Link to="../Reporting" class="btn_side">
                    <span class="ico_btn_side"><Image src={ico_04}></Image></span>
                    <span class="label_btn_side">Clinical System</span>
                </Link>
            </div>
        </div>            
    );
}

export default SideNav;